import request from '../utils/request';

// 店铺管理API
export const shopApi = {
  // 分页查询店铺列表
  getShopList: (params) => {
    return request({
      url: '/store/list',
      method: 'post',
      data: {
        page: params.page || 1,
        pageSize: params.pageSize || 10,
        startTime: params.startTime,
        endTime: params.endTime,
        sortField: params.sortField || 'createTime',
        sortOrder: params.sortOrder || 'desc',
        ...params
      }
    });
  },

  // 根据ID获取店铺详情
  getShopDetail: (id) => {
    return request({
      url: `/store/${id}`,
      method: 'get'
    });
  },

  // 新增店铺
  createShop: (data) => {
    return request({
      url: '/store/add',
      method: 'post',
      data
    });
  },

  // 更新店铺
  updateShop: (data) => {
    return request({
      url: '/store/update',
      method: 'put',
      data
    });
  },

  // 删除店铺
  deleteShop: (id) => {
    return request({
      url: `/store/${id}`,
      method: 'delete'
    });
  },

  // 更新店铺状态
  updateShopStatus: (data) => {
    return request({
      url: '/store/update-status',
      method: 'put',
      data
    });
  }
}; 